import React from 'react';

import { SortOrder } from 'src/api';
import type { SortOption } from 'src/types/sort';

import type { FilterContextValue } from './types';

export const DEFAULT_SORT_OPTION_VALUE = {
  columnKey: 'createdAt' as const,
  order: SortOrder.Desc,
  nonNull: true,
} as const satisfies SortOption;

export const DEFAULT_FILTER_CONTEXT_VALUE: FilterContextValue = {
  filter: {},
  tableFilter: {},
  setFilter: () => {},
  setTableFilter: () => {},
  sortOption: DEFAULT_SORT_OPTION_VALUE,
  sortQueryVariable: DEFAULT_SORT_OPTION_VALUE,
  setSortOption: () => {},
  queryParams: { filter: {}, sort: null },
};

export const FilterContext = React.createContext<FilterContextValue>(DEFAULT_FILTER_CONTEXT_VALUE);
